import { Component, Inject, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransformationNode } from '../../models/transformationNode';

@Component({ standalone:false,
  selector: 'edit-node-function-dialog',
  templateUrl: 'edit-node-function-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['edit-node-function-dialog.component.scss']
})
export class EditNodeFunctionDialogComponent {
  public title: string= "Edit Node Function";
  public message: string = "";
  public confirmButtonText = "OK";
  public cancelButtonText = "Cancel";

  public node!:TransformationNode;
  public availableFunctions=[{name:"Count", xPathFunction:"count", resultType:"numeric", formatLabel:"Numeric format", formatHint:"Optional. Use '0' and '.' to force the amount of decimals. Example: 0.00"},{name:"Sum", xPathFunction:"sum", resultType:"numeric", formatLabel:"Numeric format", formatHint:"Optional. Use '0' and '.' to force the amount of decimals. Example: 0.00"}];
  public functionForm: FormGroup;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any, private dialogRef: MatDialogRef<EditNodeFunctionDialogComponent>) {
    this.functionForm = new FormGroup({
        function: new FormControl(null, Validators.required),
        nodePath: new FormControl(null, Validators.required),
        format: new FormControl(null)
    });
    if(data){
        this.title=data.title;
        this.message = data.message || this.message;
        if (data.buttonText) {
            this.confirmButtonText = data.buttonText.ok || this.confirmButtonText;
            this.cancelButtonText = data.buttonText.cancel || this.cancelButtonText;
        }
        if (data.transformationNode){
            this.node=data.transformationNode;
        }
    }
  }

  ngOnInit(){
    this.prepopulate();
  }

  private prepopulate(){    
    if(this.node.function?.startsWith("count")) {
      this.functionForm.get("function")!.setValue(this.availableFunctions[0]);
      let availableNodePaths = this.availableNodePaths;
      let xPathList = this.node.function.substring(7, this.node.function.length-2).split('|');
      let selectedNodePaths:string[]=[];
      xPathList.forEach(xPath=>{
        let nodePath = availableNodePaths.find(np=>np==xPath);
        if(nodePath) selectedNodePaths.push(nodePath)
      });
      this.functionForm.get("nodePath")!.setValue(selectedNodePaths);
    }
    else if(this.node.function?.startsWith("sum")) {
      this.functionForm.get("function")!.setValue(this.availableFunctions[1]);
      let availableNodePaths = this.availableNodePaths;
      let xPathList = this.node.function.substring(5, this.node.function.length-23).split('|');
      let selectedNodePaths:string[]=[];
      xPathList.forEach(xPath=>{
        let nodePath = availableNodePaths.find(np=>np==xPath);
        if(nodePath) selectedNodePaths.push(nodePath)
      });
      this.functionForm.get("nodePath")!.setValue(selectedNodePaths);
    }
    if(this.node.functionResultFormat){
      this.functionForm.get("format")!.setValue(this.node.functionResultFormat)
    }
  }
  
  get availableNodePaths(){
    let flatPathArray:string[]=[];
    if(this.functionForm.get("function")!.value?.name=="Sum"){
        this.node?.parentNode.getChildNodePaths("",flatPathArray,false,false);
    }
    else if(this.functionForm.get("function")!.value?.name=="Count"){
        this.node?.parentNode.getChildNodePaths("",flatPathArray,false,true);
    }
    return flatPathArray;
  }

  get canConfirm(){
    return this.functionForm.valid;
  }

  onConfirmClick(): void {
    let xPathFunction = this.functionForm.get("function")!.value.xPathFunction;
    let nodePathList = this.functionForm.get("nodePath")!.value as string[];
    let xPath:string=this.functionForm.get("function")!.value.xPathFunction + "((";
    nodePathList.forEach(nodePath=>{
      xPath += nodePath +"|";
    });
    if(xPath.endsWith('|')) xPath=xPath.substring(0,xPath.length-1);
    if(xPathFunction=='sum'){
      xPath += ")[number(.)=number(.)])"; //only consider numeric value elements to avoid NaN result
    }
    else{
      xPath +="))";
    }
    if(this.functionForm.get("format")!.value){
        this.node.functionResultFormat = this.functionForm.get("format")!.value;
    }
    this.node.function=xPath;
    this.dialogRef.close(true);
  }

  onCancelClick(): void {
    this.dialogRef.close(undefined);
  }

}